module.exports = __webpack_public_path__ + "44cbee92.png";